import React from 'react'
import { StickyContainer } from 'react-sticky'
import CssBaseline from '@material-ui/core/CssBaseline'
import ScrollToTop from '../../utils/ScrollToTop'
import ScrollTop from '../ScrollTop/ScrollTop'
import { Routes } from '../../routes'
import { useStyles } from './Styles'
import Header from '../Header'
import ThemeHeader from '../Dashboard/Header/Header'
import { useKeycloak } from '@react-keycloak/web'
import { LanguageConsumer } from '../../LanguageContext'


const Layout = () => {
  const classes = useStyles()
  const { keycloak } = useKeycloak()
  return (
    <div className={classes.pageWrapper}>
      <CssBaseline/>
      <ScrollToTop/>
      <StickyContainer>
        {!!keycloak?.authenticated &&
        <>
          <Header/>
          <LanguageConsumer>
            {({ locale }) => (
              <ThemeHeader locale={locale}/>
            )}
          </LanguageConsumer>
        </>
        }
        <main className={classes.content}>
          <Routes/>
        </main>
      </StickyContainer>
      <ScrollTop scrollStepInPx="50" delayInMs="0"/>
    </div>
  )
}

export default Layout
